<template>
  <div
    class="tab-contaner"
    :class="{ 'flex flex-column': flex }"
  >
    <div class="tab-nav-container">
      <ul
        class="tab-nav"
        :class="tabClass"
      >
        <li
          v-for="item in tabItems"
          :key="item.tabKey"
          :title="[item.description ? item.description : item.title]"
          class="tab"
          :class="[
            {
              active: modelValue && modelValue == item.tabKey,
            },
            item.tabClass,
          ]"
          @click="activeTab(item)"
        >
          {{ item.title }}
        </li>
      </ul>
      <div class="hideForm">
        close
      </div>
      <slot name="more" />
    </div>
    <div
      ref="tabContent"
      class="tab-view p-6"
      :class="[viewClass, { 'flex flex-column': flex }]"
    >
      <slot />
      <slot name="show-tab" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    tabItems: {
      type: Array,
      default: new Array(),
    },
    modelValue: {},
    /**
     * flex tab content
     */
    flex: {
      type: Boolean,
      default: false,
    },
    viewClass: {
      type: String,
      default: '',
    },
    tabClass: {
      type: String,
      default: '',
    },
  },
  setup (props, { emit }) {
    const activeTab = (item) => {
      // TODO => Active tab
      // emit('update:modelValue', item.tabKey);
      emit('activeTab', item)
    }

    return { activeTab }
  },
  name: 'MsTabDynamic',
})
</script>
<style lang="scss" scoped>

.tab-view{
  position: relative;
}
:deep(.progress-tab) {
  position: absolute;
  height: 3px;
  background-color: $color-primary;
  left: 0;
  top: -4px;
  z-index: 10000;
}

:deep(.white-display){
  position: absolute;
  background-color: #fff;
  right: 0;
  left: 0;
  top: 0px;
  bottom: 0;
  z-index: 10000;
}
@import '@/assets/scss/components/MsTab.scss';
</style>
